import { Copy } from "lucide-react";
import React from "react";
import { CollapsePanel } from "./CollapsePanel";

export const PaOnFileDetails = ({ paOnFileDetails }) => {
  const caseId = paOnFileDetails?.reflexedCaseId;

  return (
    <CollapsePanel labelText="PA on File Case">
      <div className="d-flex flex-column align-items-center justify-content-center p-3 rounded bg-info bg-opacity-10 text-center">
        <div className="text-muted fw-semibold text-uppercase mb-2">Reflexed to PA Case</div>
        <div className="d-flex align-items-center justify-content-center">
          <a href={`/cases/${caseId}`} target="_blank" rel="noopener noreferrer" className="btn bg-info bg-opacity-50 py-1">
            <span className="fw-bold">{caseId}</span>
          </a>
          <a className="copy text-muted btn-copy d-print-none" href="#" data-clipboard-text={caseId}>
            <Copy className="copy-icon" size={12} />
          </a>
        </div>
      </div>
    </CollapsePanel>
  );
};
